import React, { useEffect, useRef, useState } from 'react'
import logoIcon from "../assets/images/login/login-logo.png";
import chartImg1 from "../assets/images/login/slide-image-1.png";
import chartImg2 from "../assets/images/login/slide-image-2.png";
import chartImg3 from "../assets/images/login/slide-image-3.png";
import chartImg4 from "../assets/images/login/slide-image-4.png";
import logo from "../assets/images/logo.svg";
import star from "../assets/images/login/star.png";

const slides = [
  {
    heading: "מנוע AI הראשון בישראל",
    subHeader:"לאיסוף וניתוח נתוני ביטוח ופיננסים",
    description:"הבינה המלאכותית כבר כאן תנו לטכנולוגיה לעבוד <br> בשבילכם ולחסוך לכם כסף! </br>עם כלים מתקדמים ותמיכה נכונה, אפשר לשפר בקלות <br> את הדרך שבה אתם מנהלים את הכסף",
    image:chartImg1,
    className:"slide1"
  },
  {
    heading: "אנחנו מנגישים מידע פיננסי שיעזור לכם", 
    subHeader:"לקבל את ההחלטות הנכונות",
    image:chartImg2,
    className:"slide2",
    description: "המערכת שלנו מאגדת את כל הנתונים הפיננסיים שלכם </br> ומנתחת אותם בעזרת טכנולוגיית AI, כדי להציג </br> תמונה אובייקטיבית וברורה של האפשרויות </br> בשוק - וההחלטה בידיים שלכם"
  }, 
  {
    heading: "מנגישים את המידע הפיננסי שלכם",
    subHeader:"בשפה פשוטה וברורה",
    image:chartImg3,
    className:"slide3",
    description: "אנחנו יודעים שפיננסים יכולים להרגיש כמו שפה זרה אבל לא</br>אצלנו, המערכת שלנו מציגה את המידע הפיננסי שלכם </br> בצורה פשוטה וברורה, מוסיפה הסברים מפורטים<br>ואנחנו תמיד זמינים עבורכם גם בוואטסאפ "
  },
  {
    heading: "כל הביטוחים במקום אחד",
    subHeader:"שקוף ופשוט בשבילכם", 
    image: chartImg4,
    className:"slide4",
    description:"כבר לא צריך לחפש בין מסמכים וחברות שונות</br>המערכת שלנו מרכזת את כל הביטוחים שלכם במקום אחד, </br>מציגה כמה אתם באמת משלמים, ונותנת המלצות חכמות <br>לשיפור ולחיסכון בעלויות כולל השוואות בין החברות"
  },
  ];

const LoginCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const intervalRef = useRef(null);
  const slideRef = useRef(null);
  const extendedSlides = [...slides, slides[0]];

  useEffect(() => {
    startAutoSlide();
    return () => clearInterval(intervalRef.current);
  }, []);

  useEffect(() => {
    if (activeIndex === slides.length) {
      const timer = setTimeout(() => {
        setIsTransitioning(false);
        setActiveIndex(0);
      }); 
      return () => clearTimeout(timer);
    }
  }, [activeIndex]);

  const startAutoSlide = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      goToNextSlide();
    }, 3000);
  };

  const goToNextSlide = () => {
    setIsTransitioning(true);
    setActiveIndex(prev => prev + 1);
  };

  const handleIndicatorClick = (index) => {
    if (activeIndex) {
      setIsTransitioning(true);
      setActiveIndex(index);
      startAutoSlide(index);
    }
  };

  const slidesContainerStyle = {
    display: "flex",
    transition: isTransitioning ? "transform 0.3s ease-out" : "none",
    transform: `translateX(${activeIndex * 100}%)`,
  };
  return (
    <div className="form_slider" style={{ overflow: "hidden" }}>
        <div className="loging_logo_div">
          <img className="white_logo" src={logoIcon} alt="logo" />
        </div>
        <div className="login_mob_head">
          <img src={logo} alt="logo" />
        </div>
       <div className="form_slide_main_outer">
       <div className="form_slide_main" ref={slideRef} style={slidesContainerStyle}>
          {extendedSlides.map((slide, index) => (
            <div
              key={index}
              className={`slide_div ${slide.className || ""}`}
              style={{
                flexShrink: 0,
                width: "100%",
              }}
            >
              <div className="content_wrapper">
                <h2 className="login_head">{slide.heading}</h2>
                <div  className=""><p className='hightlight'>{slide.subHeader}</p></div>
                <p className="login_desc" dangerouslySetInnerHTML={{ __html: slide.description }}></p>
              </div>
              <div className="chart_view">
                <img
                  draggable={false}
                  className="chart"
                  src={slide.image}
                  alt="chart"
                />
                <img
                  draggable={false}
                  className="star_img"
                  src={star}
                  alt="chart"
                />
              </div>
              <div>
              
                </div>
            </div>
          ))}
        </div>
          <div className="indicator_container">
            {slides.map((_, index) => (
              <div
                onClick={() => handleIndicatorClick(index)}
                key={index}
                className={`indicator ${activeIndex === index ? "active" : ""}`}
              ></div>
            ))}
          </div>
       </div>
      </div>
  )
}

export default LoginCarousel